/* Board 6 lane B6E (2026-10-30), product pages only. Loaded (defer) by layout/theme.liquid while umbra_pdp_gallery_line or
   umbra_sys_bv is on; each part runs only under its html class, so it does nothing elsewhere.

   P1 gallery line (html.ub6e-gl): under 770 px a 2 px line at the foot of the photo shows where the shopper is in the gallery,
   in place of the dots and the "1 / 15" pill (assets/umbra-b6e.css hides those and makes each slide 86% wide so the next one
   peeks). The thumb is 1/N of the track and is moved with a transform from the slider's own scroll position, once per frame,
   passive, with the extent measured only on build and resize. It follows the theme's variant filtering (inline display none).

   X8 reviews (html.ub6e-bv): the Bazaarvoice reviews widget draws into an OPEN shadow root of [data-bv-show="reviews"]. Page CSS
   cannot enter it; an adopted stylesheet can, without adding a node to the widget's tree (so the MutationObserver of
   assets/umbra-cls-reserve.js, which watches that tree, sees nothing). Where adoptedStyleSheets is missing, one style element
   is appended instead. The sheet sets faces, the 8 px control corners (G7D S5), 16 px fields and 4 px bars. It never hides anything.
   B6P-3 (Mete 2026-10-30): the widget keeps Bazaarvoice's own background, and customer photos are 8 px squares.
   The rating averages ("5.0") are marked data-ub6e-num so they keep one line (the "5. / 0" wrap). */
(function () {
  if (window.__ub6e) return;
  window.__ub6e = true;
  var html = document.documentElement;

  function gallery() {
    var media = document.getElementById('product-media');
    var viewer = media && media.querySelector('.media-gallery__viewer');
    var list = media && media.querySelector('.media-viewer');
    if (!viewer || !list) return;
    var bar = document.createElement('div');
    bar.className = 'ub6e-gline';
    bar.setAttribute('aria-hidden', 'true');
    bar.hidden = true;
    bar.appendChild(document.createElement('i'));
    viewer.appendChild(bar);
    var n = 0, max = 0, raf = 0, t = 0;
    function paint() {
      raf = 0;
      if (n < 2) return;
      var p = max > 0 ? Math.min(1, Math.max(0, list.scrollLeft / max)) : 0;
      bar.style.setProperty('--ub6e-gl-x', (p * (n - 1) * 100).toFixed(2) + '%');
    }
    function build() {
      n = Array.prototype.filter.call(list.querySelectorAll('.media-viewer__item'), function (li) { return li.clientWidth > 0; }).length;
      max = list.scrollWidth - list.clientWidth;
      bar.hidden = n < 2;
      bar.style.setProperty('--ub6e-gl-w', (100 / Math.max(n, 1)).toFixed(3) + '%');
      paint();
    }
    function later() { clearTimeout(t); t = setTimeout(build, 120); }
    list.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(paint); }, { passive: true });
    window.addEventListener('resize', later, { passive: true });
    document.addEventListener('on:variant:change', function () { setTimeout(build, 350); });
    if ('MutationObserver' in window) new MutationObserver(later).observe(list, { attributes: true, subtree: true, attributeFilter: ['style', 'class'] });
    build();
  }

  var BV_CSS = [
    '#bv_review_maincontainer, #bv_review_maincontainer * { font-family: var(--body-font-family) !important; }',
    'h1, h2, h3, h4, #bv_review_maincontainer :is(h1, h2, h3, h4) { font-family: var(--heading-font-family) !important; font-weight: 600 !important; letter-spacing: 0 !important; }',
    /* G7D S5 (design gate 2026-10-30): one 8 px corner for every control, no pill and no square: text buttons (Helpful,
       Report, Load more, Write a review), icon-only buttons (the rate-this stars, the photo arrows), the search field, the
       Rating and Locale comboboxes and the Sort box (its border sits on the div three levels above its combobox). */
    'button, [role="button"], select { border-radius: 8px !important; font-family: var(--navigation-font-family) !important; }',
    '[role="combobox"], div:has(> div > div > [role="combobox"]) { border-radius: 8px !important; }',
    'button:not(:has(:not(svg, svg *))), [role="button"]:not(:has(:not(svg, svg *))) { border-radius: 8px !important; }',
    /* B6R2-3: the write-a-review stars are 5 [role=button] in one [role=group], each drawing its square tile with a plain
       inner div (54x51, 4 px). Matched by roles and the 5-star shape, not by BV's hashed class names. */
    '[role="group"]:has(> [role="button"] ~ [role="button"] ~ [role="button"] ~ [role="button"] ~ [role="button"]) > [role="button"] > div { border-radius: 8px !important; }',
    'input[type="text"], input[type="search"], input:not([type]) { border-radius: 8px !important; font-size: 16px !important; }',
    'textarea { border-radius: 8px !important; font-size: 16px !important; }',
    '[role="progressbar"], [role="progressbar"] > *, [role="meter"], [role="meter"] > * { border-radius: 4px !important; overflow: hidden; }',
    /* B6P-3: customer photo thumbnails (buttons holding an img) are 8 px squares, their inner layers too */
    'button:has(img), [role="button"]:has(img), button:has(img) > *, [role="button"]:has(img) > *, button:has(img) img, [role="button"]:has(img) img { border-radius: 8px !important; }',
    '[data-ub6e-num] { white-space: nowrap !important; min-width: max-content !important; }'
  ].join('\n');

  function reviews() {
    var sheet = null;
    try { sheet = new CSSStyleSheet(); sheet.replaceSync(BV_CSS); } catch (e) { sheet = null; }
    var tries = 0;
    function dress(root) {
      if (sheet && 'adoptedStyleSheets' in root) {
        if (Array.prototype.indexOf.call(root.adoptedStyleSheets, sheet) === -1) root.adoptedStyleSheets = Array.prototype.slice.call(root.adoptedStyleSheets).concat([sheet]);
      } else if (!root.querySelector('style[data-ub6e]')) {
        var st = document.createElement('style');
        st.setAttribute('data-ub6e', '');
        st.textContent = BV_CSS;
        root.appendChild(st);
      }
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), node, c = 0;
      while ((node = w.nextNode()) && c++ < 6000) {
        var el = node.parentElement;
        if (el && !el.hasAttribute('data-ub6e-num') && /^\s*\d\.\d\s*$/.test(node.nodeValue || '')) el.setAttribute('data-ub6e-num', '');
      }
    }
    function look() {
      var hosts = document.querySelectorAll('.umbra-rv-box [data-bv-show="reviews"]'), found = false;
      for (var i = 0; i < hosts.length; i++) {
        var root = hosts[i].shadowRoot;
        if (!root) continue;
        found = true;
        if (root.__ub6e) continue;
        root.__ub6e = true;
        dress(root);
        if ('MutationObserver' in window) {
          (function (r) {
            var d = 0;
            new MutationObserver(function () { clearTimeout(d); d = setTimeout(function () { dress(r); }, 300); }).observe(r, { childList: true, subtree: true });
          })(root);
        }
      }
      /* Bazaarvoice starts late (after the consent answer on some markets): look every 0.7 s for up to 90 s */
      if (!found && ++tries < 130) setTimeout(look, 700);
    }
    look();
  }

  function go() {
    if (html.classList.contains('ub6e-gl')) gallery();
    if (html.classList.contains('ub6e-bv')) reviews();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go, { once: true });
  else go();
})();
